import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { batchQuoteAddToQueue } from 'state/batchForm/batchForm.action';
import {
  batchFormsCloneRequestedThunk,
  batchFormsDeletedThunk,
  batchFormsOpenedInQuoteWorkspaceThunk,
  batchQuoteAbortedThunk,
} from 'state/batchForm/batchForm.thunks';
import { resetDefaultDatesThunk } from 'state/formData/formData.thunks';
import {
  canAbortBatchForm,
  canCloneBatchForm,
  canDeleteBatchForm,
  canOpenInQuoteWorkspaceBatchForm,
  canPriceBatchForm,
  canRefreshBatchFormDate,
} from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

import type {
  BatchFormOptionsMenuDispatchProps,
  BatchFormOptionsMenuOwnProps,
  BatchFormOptionsMenuStateProps,
} from './FormOptionsMenu';

export function mapStateToProps(
  state: AppState,
  ownProps: BatchFormOptionsMenuOwnProps,
): BatchFormOptionsMenuStateProps {
  return {
    canPrice: canPriceBatchForm(state, ownProps.formId),
    canDelete: canDeleteBatchForm(state, ownProps.formId),
    canDuplicate: canCloneBatchForm(state, ownProps.formId),
    canRefreshDates: canRefreshBatchFormDate(state, ownProps.formId),
    canAbort: canAbortBatchForm(state, ownProps.formId),
    canOpenInQuoteWorkspace: canOpenInQuoteWorkspaceBatchForm(state, ownProps.formId),
  };
}

export function mapDispatchToProps(
  dispatch: ThunkDispatch,
  ownProps: BatchFormOptionsMenuOwnProps,
): BatchFormOptionsMenuDispatchProps {
  return {
    onDelete() {
      logAnalytics.trackEvent('Batch Workspace', 'Delete from menu');
      dispatch(batchFormsDeletedThunk(ownProps.tabId, [ownProps.formId]));
    },
    onOpenInQuoteWorkspace() {
      logAnalytics.trackEvent('Batch Workspace', 'Open in quote workspace from menu');
      dispatch(batchFormsOpenedInQuoteWorkspaceThunk([ownProps.formId]));
    },
    onDuplicate() {
      logAnalytics.trackEvent('Batch Workspace', 'Duplicate from menu');
      dispatch(batchFormsCloneRequestedThunk(ownProps.tabId, [ownProps.formId]));
    },
    onPrice() {
      logAnalytics.trackEvent('Batch Workspace', 'Price from menu');
      dispatch(batchQuoteAddToQueue(ownProps.tabId, [ownProps.formId]));
    },
    onResetDates() {
      logAnalytics.trackEvent('Batch Workspace', 'Refresh dates');
      dispatch(resetDefaultDatesThunk(ownProps.tabId, ownProps.formId));
    },
    onAbort() {
      logAnalytics.trackEvent('Batch Workspace', 'Cancel quote');
      dispatch(batchQuoteAbortedThunk(ownProps.formId));
    },
  };
}

export const connectedBatchFormOptionsMenu = connect(mapStateToProps, mapDispatchToProps);
